module.exports = __webpack_public_path__ + "src/client/assets/img/logo-white@2x.png";